<sc-flex vertical fitHeight stretchContent
    class="transport-option-gc-connection-dialog">

    <sc-dialog-title>
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.sac-client.transport-option-gc-connection-dialog.title"></sc-dictionary-label>
    </sc-dialog-title>


    <sc-flex-fitting-content vertical>

        <sc-padding>

            <sc-flex fitHeight [centered]="true" vertical>
                <ng-container [formGroup]="optionSelectionFormGroup">
                    <mat-form-field class="option-selection" appearance="fill">
                        <mat-select formControlName="option" name="option">
                            <mat-option *ngFor="let option of optionsWithCase" [value]="option">
                              <sc-dictionary-label [dictionaryKey]="option.nameDictionaryKey"></sc-dictionary-label>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>

                <div class="qr-code-box">
                    <qrcode *ngIf="qrCodeUrl" [qrdata]="qrCodeUrl" [scale]="8"></qrcode>
                </div>
            </sc-flex>

        </sc-padding>
    </sc-flex-fitting-content>



    <sc-actionbar>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-close-button mat-dialog-close (click)="closeDialog()" dictionaryKey="shared.selection-dialog.action.close"></sc-close-button>
    </sc-actionbar>

</sc-flex>
